import { Component, Inject, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, Scroll } from '@angular/router';
import { AppServiceService } from './_services/app-service.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './_services/auth.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // encapsulation: ViewEncapsulation.Emulated,
})

export class AppComponent implements OnInit {
  constructor(private router: Router, private appService: AppServiceService,
    private authService: AuthService,
    public responsive: BreakpointObserver
  ) {
  }

  sideBarOpen = true;
  isPhoneviewed = false;
  scrollPosition: number;


  sideBarToggler() {
    this.sideBarOpen = !this.sideBarOpen;
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.scrollPosition = window.scrollY;
      }
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}



